module.exports = __webpack_public_path__ + "static/media/microbiome_collage.7d601e3a.webp";